// extracted by extract-css-chunks-webpack-plugin
module.exports = {"search_widget":"SearchWidget__search_widget--38bNH","search_control":"SearchWidget__search_control--2dQap","buttons":"SearchWidget__buttons--1ODrc"};